var $globalHeader = $(".global-header");

$(function () {
	let headerHeight = $globalHeader.outerHeight();
	$("body").css({
		"--header-height": headerHeight + "px",
	});
	window.headerHeight = headerHeight;

	$(window).on("scroll", function () {
		var scrollTop = window.pageYOffset || $(document).scrollTop();
		$globalHeader.toggleClass("scrolling", scrollTop > 0);
	});

	$globalHeader.on("sticky-end", function () {
		$("#sticky-wrapper").css({
			height: headerHeight,
		});
	});

	const menuLeftMapping = new MappingListener({
		selector: ".menu-wrapper-left",
		mobileWrapper: ".menu-mobile-body",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-left",
		desktopMethod: "prependTo",
		breakpoint: 1025,
	}).watch();

	const menuRightMapping = new MappingListener({
		selector: ".menu-wrapper-right",
		mobileWrapper: ".menu-mobile-body",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-right",
		desktopMethod: "prependTo",
		breakpoint: 1025,
	}).watch();

	$(".close-menu-mobile, .menu-mobile-backdrop").on("click", function () {
		$(".menu-mobile").removeClass("show");
		$("body").removeClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeOut();
	});

	$(".toggle-sub-menu").each(function (index, el) {
		$(el).on("click", function () {
			$(el).next().slideToggle();
		});
	});

	$(".menu-toggle").on("click", function () {
		$(".menu-mobile").addClass("show");
		$("body").addClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeIn();
	});

	if ($(window).width() > 1025) {
		$(".menu > ul > .menu-item-has-children").each(function (index, el) {
			let $el = $(el);
			let $id = $(el).attr("id");
			let subMenu = $(el).find("> .sub-menu");
			$(".mega-menu").append(subMenu);
			subMenu.wrapAll(
				"<div class='mega-menu-item' data-target='" + $id + "'></div>"
			);
			$el.on("mouseenter", function () {
				let $target = $(".mega-menu-item[data-target='" + $id + "']");
				$target.addClass("active");
				$target.siblings().removeClass("active");
			});
		});
		$(".mega-menu-item").on("mouseenter", function () {
			$(this).addClass("active");
			$(this).siblings().removeClass("active");
		});
		$(".global-header").on("mouseleave", function () {
			$(this).find(".mega-menu-item").removeClass("active");
		});
	}
});
